import Section from '../Section';

export default class ScrollingBanner extends Section {

}
